import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { ProgressBar } from 'primereact/progressbar';
import { Panel } from 'primereact/panel';
import { Button } from 'primereact/button';
import { tachoApi } from '../../api/services';

const plural = (n) => `${n} fajl${n === 1 ? '' : 'ova'}`;

/* Prozor "Unos aktivnosti": upload DDD/ESM fajlova kartica, progress i lista uspeha/neuspeha. */
export default function ImportResultDialog({ files, url, onClose, onFinished }) {
    const [state, setState] = useState({ status: 'Unos aktivnosti započet', done: false, result: null });

    useEffect(() => {
        let cancelled = false;
        tachoApi.importFiles(files, url)
            .then((result) => !cancelled && setState({ status: 'Unos aktivnosti završen', done: true, result }))
            /* kao stari prozor: i posle greške se prikazuju oba spiska (0 fajlova) */
            .catch(() => !cancelled && setState({ status: 'Greška prilikom unosa aktivnosti', done: true, result: { succeeded: [], failed: [] } }))
            .finally(() => onFinished && onFinished());
        return () => { cancelled = true; };
    }, []);

    const { result, done, status } = state;
    const failed = done && status.startsWith('Greška');
    return (
        <Dialog visible header="Unos aktivnosti" onHide={onClose} style={{ width: '40rem' }} modal
            footer={<Button label="Zatvori" severity="secondary" outlined onClick={onClose} disabled={!done} />}>
            <div className="report-progress" style={{ marginTop: 0, marginBottom: '1.25rem' }}>
                <div className="report-progress-head"><span aria-live="polite">{status}</span><span>{plural(files.length)}</span></div>
                <ProgressBar mode={done ? 'determinate' : 'indeterminate'} value={done ? 100 : 0} showValue={false}
                    color={failed ? 'var(--ui-danger)' : undefined} />
            </div>
            {result && (
                <div className="stack" style={{ gap: '.6rem' }}>
                    <Panel header={<span><i className="pi pi-check-circle" style={{ color: 'var(--ui-ok)', marginRight: '.5rem' }} aria-hidden="true" />{`Uspeh: ${plural(result.succeeded.length)}`}</span>}
                        toggleable collapsed={result.succeeded.length === 0}>
                        <div className="import-list">{result.succeeded.map((m, i) => <div key={i} title={m}>{m}</div>)}</div>
                    </Panel>
                    <Panel header={<span className={result.failed.length ? 'error-report' : ''}><i className="pi pi-times-circle" style={{ marginRight: '.5rem' }} aria-hidden="true" />{`Neuspeh: ${plural(result.failed.length)}`}</span>}
                        toggleable collapsed={result.failed.length === 0}>
                        <div className="import-list">{result.failed.map((m, i) => <div key={i} className="error-report" title={m}>{m}</div>)}</div>
                    </Panel>
                </div>
            )}
        </Dialog>
    );
}
